import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-priority-card',
  imports: [NgOptimizedImage],
  templateUrl: './priority-card.component.html',
  styleUrl: './priority-card.component.scss',
  host: {
    '[style.flex-direction]': 'layout()'
  }
})
export class PriorityCard {
  header = input.required<string>();
  subheader = input.required<string>();
  src = input.required<string>();
  alt = input<string>('');
  layout = input<'row' | 'row-reverse'>('row');
  priority = input<boolean>(false);
}
